import { logFormData } from 'shared/lib/logFormData';

import type { TWorkplaceFormFields } from 'entities/creditForm';
import { setWorkplaceInfo, sendStepsAnalyticsEvents } from 'entities/creditForm';

import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo';

export const submitWorkplaceForm =
  (actualData: TWorkplaceFormFields): ThunkResult<void> =>
  async (dispatch) => {
    logFormData('WorkplaceInfo FormStep SubmitData', actualData);
    dispatch(setWorkplaceInfo({ data: actualData, isFullFilled: true }));
    dispatch(sendStepsAnalyticsEvents([3], WorkplaceInfoTexts, 'manual'));
  };
